import styled from 'styled-components';
import { Button } from '../../../../components/Buttons';
import { Typography } from '@material-ui/core';
import { Box } from '@material-ui/core';

export const InscriptionsContainer = styled.article`
	${props => props.theme.breakpoints.up('xs')} {
		padding: 22% 5% 6% 5%;
	}

	${props => props.theme.breakpoints.up('sm')} {
		padding: 15% 5% 5% 5%;
	}

	${props => props.theme.breakpoints.up('md')} {
		padding: 8% 4.5% 3% 11%;
	}

	.data-grid {
		${props => props.theme.breakpoints.up('xs')} {
			text-align: center;
			p {
				margin: 7% 12% 3% 12%;
			}
			h1 {
				margin: 8px 8px 0px 8px;
			}
		}
		${props => props.theme.breakpoints.up('md')} {
			text-align: left;
			padding-bottom: 80px;
			span {
				margin: 0%;
			}
			h1 {
				margin: 0px 0px 0px -4px;
			}
			p {
				margin: 4% 0%;
			}
		}
		.promo-grid {
			background: ${props => props.theme.label.color};
			margin: 1.25rem 0;
			padding: 0.5rem 1.25rem;
			width: 100%;
			border-radius: 8px;
			p {
				margin: 0;
				text-align: initial;
			}
			${props => props.theme.breakpoints.up('md')} {
				width: 87.5%;
			}
		}
		.attributes-grid {
			margin: 1.25rem 0;
			${props => props.theme.breakpoints.up('xl')} {
				width: 70%;
			}
			.attribute-item {
				width: 100%;
			}
		}
		.MuiButton-label {
			text-transform: none;
		}
	}
`;

export const StyledMessageButton = styled(Button)`
	&.MuiButton-root {
		width: auto;
		padding: 5px 10px;
	}

	.MuiButton-label {
		text-transform: initial;
	}
`;

export const Title = styled(Typography)`
	${props => props.theme.breakpoints.up('md')} {
		&.MuiTypography-h1 {
			line-height: 60px;
		}
	}
`;

export const StyledLink = styled.span`
	width: 100%;
	cursor: pointer;
	color: ${props => props.theme.label.color};
	font-weight: 500;
`;

export const StyledLinkBox = styled(Box)`
	width: fit-content;
	::after {
		margin-top: 5px;
		content: '';
		display: block;
		border: 1px solid ${props => props.theme.label.color};
	}
`;
